export default "<div class=\"map-container\">\n  <div class=\"map-frame\">\n    <div id=\"mapId\"></div>\n  </div>\n</div>\n";